export function checkisSearchUnavailable({ autocomplete, searchable, isSameValue }) {
    return autocomplete || !searchable || isSameValue;
}
